// De onde o aluno abriu o painel de compra. Vai nos eventos do painel, na compra
// feita por ele (sparkecommerce grava como utm_content do carrinho) e no link do
// checkout que ele abre, para a venda concluída no checkout também ser atribuída
// ao painel (HET-4428).
export type DirectPurchaseEntry = 'home_section' | 'next_learning'

export const PURCHASE_ORIGIN = {
  utm_source: 'members_area',
  utm_medium: 'direct_purchase',
} as const

// Acrescenta a origem ao link do checkout. Link que já traz UTM fica como está:
// a atribuição que o produtor montou vale mais que a nossa.
export function withPurchaseOrigin(
  url: string,
  entry: DirectPurchaseEntry,
): string {
  if (!url || /[?&]utm_[a-z]+=/i.test(url)) return url

  const hashIndex = url.indexOf('#')
  const base = hashIndex === -1 ? url : url.slice(0, hashIndex)
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex)
  const params = Object.entries({ ...PURCHASE_ORIGIN, utm_content: entry })
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')
  const separator = !base.includes('?')
    ? '?'
    : base.endsWith('?') || base.endsWith('&')
      ? ''
      : '&'

  return `${base}${separator}${params}${hash}`
}
